/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-07 18:19:29
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-03-04 15:59:18
 */
import { formatDate } from "../../utils";
export function updateCurrSessionMsgs(state, obj) {
    if (obj.type === "init") {
        if (state.consultId) {
            let currSessionMsgs = [];
            let lastMsgTime = 0;
            obj.message.forEach(msg => {
                if (msg.time - lastMsgTime > 60 * 5) {
                    // 判断是不是今天
                    let newTime = formatDate(
                        "yyyy-MM-dd",
                        parseInt(msg.time + "000")
                    );
                    let nowDate = formatDate("yyyy-MM-dd", new Date());
                    let lastDate = formatDate(
                        "yyyy-MM-dd",
                        new Date().setDate(new Date().getDate() - 1)
                    );
                    let formatString = "EE HH:mm";
                    if (newTime === nowDate) {
                        formatString = "今天 HH:mm";
                    }
                    if (newTime === lastDate) {
                        formatString = "昨天 HH:mm";
                    }
                    lastMsgTime = msg.time;
                    currSessionMsgs.push({
                        type: "timeTag",
                        payload: {
                            text: formatDate(
                                formatString,
                                parseInt(msg.time + "000")
                            )
                        }
                    });
                }

                currSessionMsgs.push(msg);
            });
            state.oldMessage[state.consultId] = {
                nextReqMessageID: obj.nextReqMessageID,
                message: currSessionMsgs
            };
        }
    }
    if (obj.type === "put") {
        // 发出去的消息处理
        let newMsg = obj.message;
        let lastMsgTime = 0;
        let lenCurrMsgs = state.messageList.length;
        if (lenCurrMsgs > 0) {
            lastMsgTime = state.messageList[lenCurrMsgs - 1].time;
        }
        if (newMsg) {
            let cloudCustomData = JSON.parse(newMsg.cloudCustomData);
            if (newMsg.type == TIM.TYPES.MSG_CUSTOM) {
                let newobj = newMsg.payload.data
                    ? JSON.parse(newMsg.payload.data)
                    : {};
                if (
                    newobj.type == "notification" &&
                    (newobj.data.actionType == "3" ||
                        newobj.data.actionType == "12")
                ) {
                    // let returnObj = {}
                    // returnObj[cloudCustomData.id] = true
                    let newArr = state.stopChat || [];
                    newArr.push(cloudCustomData.id);
                    state.stopChat = newArr;
                }
                if (
                    newobj.type == "notification" &&
                    newobj.data.actionType == "6"
                ) {
                    let newArr = [];
                    newArr.push(cloudCustomData.id);
                    state.startChat = newArr;
                    state.startChatTime[cloudCustomData.id] =
                        newobj.data.contentDesc;
                }
                if (
                    newobj.type == "notification" &&
                    newobj.data.actionType == "8"
                ) {
                    let newArr = [];
                    newArr.push({
                        chatId: cloudCustomData.id,
                        doctorId: newobj.data.doctorid
                    });
                    state.receiveChat = newArr;
                }
            }
            if (newMsg.time - lastMsgTime > 60 * 5) {
                // 判断是不是今天
                let newTime = formatDate(
                    "yyyy-MM-dd",
                    parseInt(newMsg.time + "000")
                );
                let nowDate = formatDate("yyyy-MM-dd", new Date());
                let lastDate = formatDate(
                    "yyyy-MM-dd",
                    new Date().setDate(new Date().getDate() - 1)
                );
                let formatString = "EE HH:mm";
                if (newTime === nowDate) {
                    formatString = "今天 HH:mm";
                }
                if (newTime === lastDate) {
                    formatString = "昨天 HH:mm";
                }
                state.oldMessage[cloudCustomData.id].message.push({
                    type: "timeTag",
                    payload: {
                        text: formatDate(
                            formatString,
                            parseInt(newMsg.time + "000")
                        )
                    }
                });
            }

            state.oldMessage[cloudCustomData.id].message.push(obj.message);
            // if (obj.message.flow === 'out') {
            //     state.oldMessage[obj.message.to].message.push(obj.message)
            // }
            // //接收的消息处理
            // if (obj.message.flow === 'in') {
            //     // 如果正处于聊天页面
            //     if (state.consultId === obj.message.from) {

            //     }
            // }
        }
    }
    // 删除消息
    if (obj.type === "replace") {
        if (obj.message) {
            let cloudCustomData = JSON.parse(obj.message.cloudCustomData);
            state.oldMessage[cloudCustomData.id].message.filter(v =>
                v.ID === obj.message.ID ? obj.message : v
            );
        }
    }
    //加载更多
    if (obj.type === "concat") {
        let currSessionMsgs = [];
        let lastMsgTime = 0;
        obj.message.forEach(msg => {
            if (msg.time - lastMsgTime > 60 * 5) {
                lastMsgTime = msg.time;
                let newTime = formatDate(
                    "yyyy-MM-dd",
                    parseInt(msg.time + "000")
                );
                let nowDate = formatDate("yyyy-MM-dd", new Date());
                let lastDate = formatDate(
                    "yyyy-MM-dd",
                    new Date().setDate(new Date().getDate() - 1)
                );
                let formatString = "EE HH:mm";
                if (newTime === nowDate) {
                    formatString = "今天 HH:mm";
                }
                if (newTime === lastDate) {
                    formatString = "昨天 HH:mm";
                }
                currSessionMsgs.push({
                    type: "timeTag",
                    payload: {
                        text: formatDate("EE HH:mm", parseInt(msg.time + "000"))
                    }
                });
            }
            currSessionMsgs.push(msg);
        });
        state.oldMessage[state.consultId].message = currSessionMsgs.concat(
            state.oldMessage[state.consultId].message
        );
        if (obj.nextReqMessageID) {
            state.oldMessage[state.consultId].nextReqMessageID =
                obj.nextReqMessageID;
        }
    }

    state.messageList = state.oldMessage[state.consultId].message;
}



// WEBPACK FOOTER //
// ./src/store/mutations/index.js